import '../../../../assets/css/request_details.css'
import React, { useState, useEffect } from 'react'
import { makeStyles } from '@mui/styles';
import Toolbar from '@mui/material/Toolbar';
import Row from 'react-bootstrap/Row'
import Form from 'react-bootstrap/Form'
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import CloseIcon from '@mui/icons-material/Close';
import AppBar from '@mui/material/AppBar';
import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';
import swal from 'sweetalert';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DownloadIcon from '@mui/icons-material/Download';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import GetAppRoundedIcon from '@mui/icons-material/GetAppRounded';
import { Accordion } from 'react-bootstrap';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import Loading_animation_view from '../../../loading_animation_view/loading_animation_view';
import { get_supplier_applicant_request_details, notify_purchase_service_with_quote_upload } from '../../../../services/supplier_service';
import { get_order_productsInfos, download_order_file, check_weither_ispossible_to_proceed, download_orderRequest_quote } from '../../../../services/for_allServices';
import Order_details_modal from './order_details/order_details';
import View_refuse_reason from '../view_refuse_reason/view_refuse_reason';
import { add_quote_to_orderRequest, check_order_has_contract, contract_check } from '../../../../services/purchase_service'
import Contract_content_view from './setContract_for_order/contract_content_view';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    paper: {
        width: '100%',
        marginBottom: 16,
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    input: {
        display: 'none',
    },
}));


function Request_detail({ title, details }) {
    return (
        <div>
            <Accordion>
                <Accordion.Item eventKey="0">
                    <Accordion.Header>
                        <div className='accordion_header_content'> <span>{title}</span> </div>
                    </Accordion.Header>
                    <Accordion.Body>
                        <div className="order_form_details_container">
                            <div className="order_form_infos_container">
                                <div className='order_form_infos_title'>1 - Infos de livraison</div>
                                <Row className="mb-12">
                                    <Form.Group className="col-6">
                                        <label>Pays</label>
                                        <Form.Control
                                            required
                                            autoComplete
                                            type="text"
                                            placeholder="Pays*"
                                            value={details.delivery_country}
                                            readOnly
                                        />
                                    </Form.Group>
                                    <Form.Group className="col-6">
                                        <label>Ville</label>
                                        <Form.Control
                                            required
                                            autoComplete
                                            type="text"
                                            placeholder="Ville *"
                                            value={details.delivery_city}
                                            readOnly
                                        />
                                    </Form.Group>
                                    <Form.Group className="col-6">
                                        <label>Adresse</label>
                                        <Form.Control
                                            required
                                            autoComplete
                                            type="text"
                                            placeholder="Adresse *"
                                            value={details.delivery_address}
                                            readOnly
                                        />
                                    </Form.Group>
                                    <Form.Group className="col-6">
                                        <label>Code postal</label>
                                        <Form.Control
                                            required
                                            autoComplete
                                            type="text"
                                            placeholder="Code postal *"
                                            value={details.delivery_postCode}
                                            readOnly
                                        />
                                    </Form.Group>

                                    <Form.Group className="col-6">
                                        <label>Date de livraison souhaitée</label>
                                        <Form.Control
                                            type="date"
                                            min={(new Date()).toISOString().split('T')[0]}
                                            placeholder="Date de livraison souhaitée *"
                                            value={details.delivery_supposedDate.split(' ')[0]}
                                            readOnly
                                        />
                                    </Form.Group>
                                </Row>
                                <div className='order_form_infos_title'>2 - Autres informations</div>
                                <Row className="mb-12">
                                    {
                                        details.off_catalogue != null
                                            ? <Form.Group className="col-md-12">
                                                <label>Description de la demande</label>
                                                <Form.Control
                                                    required
                                                    autoComplete
                                                    as="textarea"
                                                    minRows={5}
                                                    placeholder="Description de la demande *"
                                                    value={details.off_catalogue}
                                                    readOnly
                                                />
                                            </Form.Group>
                                            : <></>
                                    }
                                    <Form.Group className="col-md-12">
                                        <label>Imputation</label>
                                        <Form.Control
                                            required
                                            autoComplete
                                            as="textarea" rows="3"
                                            placeholder="Imputation *"
                                            value={details.object}
                                            readOnly
                                        />
                                    </Form.Group>
                                </Row>
                            </div>
                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </div>
    )
}


function state(request_state) {
    return (
        <>
            {
                request_state === null || request_state === "demander à être changée"
                    ? <Button variant="contained" className="status_waiting">{request_state ? request_state : 'En cours'}</Button>
                    : request_state === "refusée" || request_state === "refus de validation" || request_state === "annulée" || request_state === "refusée par le fournisseur" || request_state === "non conforme"
                        ? <Button variant="contained" className="status_deny">{request_state}</Button>
                        : request_state === "sous réserve de validation"
                            ? <Button variant="contained" className="status_waiting">{request_state}</Button>
                            : <Button variant="contained" className="status_success">{request_state}</Button>
            }
        </>
    );
}

function validation_state(validation_state) {
    return (
        <>
            {
                validation_state === 0
                    ? <Button variant="contained" className="status_deny">{"refus de validation"}</Button>
                    : validation_state === null
                        ? <Button variant="contained" className="status_waiting">{"en cours de validation"}</Button>
                        : <Button variant="contained" className="status_success">{"validé"}</Button>
            }
        </>

    );
}


function Order_detail({ title, id_supplier, request_code, supplier, details, init_products_bysupplier, inner_state, is_off_cataloque, chosenSubmission, setChosenSubmission,
    products_bysupplier, setProducts_bysupplier, order_key, request_order_validation, able_to_process_order, reverify_request_order_validation }) {

    const [open_reason_modal, setOpen_reason_modal] = useState(null);
    const [setContract, setSetContract] = useState(false);

    useEffect(() => {
       //  console.log("details", details);
    }, [])

    function download_order_details_file(e, request_code, order_infos) {
       //  console.log(order_infos);
        e.stopPropagation();
        let request_code_tmp_array = request_code.split(' - ');
        const formData = new FormData();
        formData.append('order_id', order_infos.order_id);
        formData.append('request_code', request_code);
        download_order_file(formData).then((response) => {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement('a');
            fileLink.href = fileURL;
            let file_extension = '';
            const disposition = response.headers['content-disposition'];
            if (disposition && disposition.includes('filename')) {
                const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                const matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) {
                    file_extension = matches[1].replace(/['"]/g, '').split(".")[1];
                }
            }
            fileLink.setAttribute('download', request_code_tmp_array[0] + "_" + request_code_tmp_array[1] + "_" + id_supplier + "." + file_extension);
            document.body.appendChild(fileLink);
            fileLink.click();
        });
    }

    function handleCloseSetContrat() {
        setSetContract(false);
        setChosenSubmission(null);
    }

    function openContractView(submission) {
       //  console.log("submission", submission);

        setSetContract(true);

        // Update id_submission but keep the rest
        setChosenSubmission(prev => ({
            ...prev,
            id_submission: submission
        }));
    }


    return (
        <div>
            <Accordion>
                <Accordion.Item eventKey="0">
                    <Accordion.Header>
                        <div className='order_accordion_header'>
                            <div className='accordion_header_content'>
                                <span>{title}</span>
                            </div>
                            <div className='accordion_header_actions'>
                                <span className="order_state">
                                    <div className='request_state_container'>
                                        {
                                            able_to_process_order == true || ["annulée"].includes(details.order_state)
                                                ? <>
                                                    {state(details.order_state)}
                                                    {
                                                        details.order_state === "sous réserve de validation" || details.order_state === "refus de validation" || details.order_state === "refusée" || details.order_state === "annulée" || details.order_state === "refusée par le fournisseur" || details.order_state === "non conforme"
                                                            ? <span className='view_reason_button' onClick={(e) => {
                                                                e.stopPropagation();
                                                                if (inner_state.length != 0) {
                                                                    setOpen_reason_modal(inner_state.non_conformity_reason); // Use the non_conformity_reason if found
                                                                } else {
                                                                    setOpen_reason_modal((details.service_refuse_reason && details.order_state !== "refusée" && details.order_state !== "sous réserve de validation" && details.order_state !== "refusée par le fournisseur") || details.order_state === "annulée" ? details.service_refuse_reason : details.refuse_reason)
                                                                }
                                                            }}>
                                                                Motif</span>
                                                            : <></>
                                                    }
                                                </>
                                                : <>{validation_state(null)}</>
                                        }
                                    </div>
                                </span>
                                <Tooltip title="Exporter en fichier pdf" placement="bottom" >
                                    <span style={{ marginLeft: '8px' }}>
                                        <Fab size="small" onClick={(e) => download_order_details_file(e, request_code, details)} color='default' style={{ backgroundColor: '#efefef' }} className={details.order_file != null ? "round_button" : "round_button disabled_button"} >
                                            <GetAppRoundedIcon className="my_icon" />
                                        </Fab>
                                    </span>
                                </Tooltip>
                                {
                                    is_off_cataloque
                                        ? <Fab size="small" className={details.conformity_date !== null ? "" : "disabled_button"} color="info" onClick={() => openContractView(details.order_id)}>
                                            <ContentPasteIcon className="my_icon" /></Fab>
                                        : <></>
                                }
                            </div>
                        </div>
                    </Accordion.Header>
                    <Accordion.Body>
                        <Order_details_modal id_supplier={id_supplier} selected_products_details={details}
                            init_products={init_products_bysupplier} request_code={request_code} able_to_process_order={able_to_process_order}
                            products_bysupplier={products_bysupplier} setProducts_bysupplier={setProducts_bysupplier} reverify_request_order_validation={reverify_request_order_validation}
                            order_key={order_key} />
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
            {
                open_reason_modal !== null
                    ? <View_refuse_reason open_reason_modal={open_reason_modal} setOpen_reason_modal={setOpen_reason_modal} />
                    : <></>
            }

            {
                chosenSubmission != null && setContract == true
                    ? <Contract_content_view setContract={setContract} handleCloseSetContrat={handleCloseSetContrat} chosenSubmission={chosenSubmission} supplier={details.id_supplier} />
                    : <></>
            }
        </div>
    )
}

function Request_details({ request_infos, setRequest_infos, id_supplier }) {

    let user = JSON.parse(localStorage.getItem("user-info"));

    const [products_bysupplier, setProducts_bysupplier] = useState(null);
    let [init_products_bysupplier, setinit_products_bysupplier] = useState(null);
    const [inner_state, setInner_state] = useState([]);
    const [is_off_cataloque, setIs_off_cataloque] = useState(false);
    const [chosenSubmission, setChosenSubmission] = useState(null);

    const [request_validation_processes, setRequest_validation_processes] = useState([]);
    const [wait_submitting, setwait_submitting] = useState(false);
    const [details, setDetails] = useState(null);
    const classes = useStyles();

    useEffect(() => {
       //  console.log("id_supplier", id_supplier);
       //  console.log("request_infos", request_infos);
        async function get_orders_products(orders, request_code, order_number, order_state, service_accord, order_id) {
            var tmp_products_bysupplier = {};
            //console.log(orders);
            if (!orders.products) {
                setProducts_bysupplier({});
                return;
            }
            let selected_products = orders.products;
            let selected_products_tmp_array = [];
            selected_products.map((selected_product) => {
                selected_products_tmp_array.push(selected_product.product_code);
            })
            let formData = new FormData();
            formData.append('products_codes', JSON.stringify(selected_products_tmp_array));
            formData.append('request_code', request_code);
            formData.append('order_id', order_id);
            var selected_products_details_tmp_array = [];
            await get_order_productsInfos(formData).then((response) => {
               //  console.log(response.data);
                let data = response.data;
               //  console.log("data", data);
                const supplierKey = Object.keys(response.data)[0];
                setInner_state(response.data[supplierKey].inner_state);
                for (const id_supplier_name in data) {
                    data[id_supplier_name].products.map((element, id) => {
                        selected_products.map((selected_product, id) => {
                            if (selected_product.product_code === element.product_code) {
                                element.product_amount = element.product_amount ? element.product_amount : selected_product.product_amount;
                            }
                        })
                        selected_products_details_tmp_array.push(element);
                    });
                    tmp_products_bysupplier[id_supplier_name] = response.data[id_supplier_name];
                    tmp_products_bysupplier[id_supplier_name]["order_number"] = order_number;
                    tmp_products_bysupplier[id_supplier_name]["order_state"] = order_state;
                    tmp_products_bysupplier[id_supplier_name]["service_accord"] = service_accord;
                    tmp_products_bysupplier[id_supplier_name]["products"] = selected_products_details_tmp_array;
                }
            }).catch((error) => {
               //  console.log(error.response);
            });
            //console.log(tmp_products_bysupplier);
            setProducts_bysupplier(tmp_products_bysupplier);

           //  console.log("setProducts_bysupplier", tmp_products_bysupplier);

        }

        async function load_data() {
            const formData = new FormData();
            formData.append('request_code', request_infos.request_code);
            formData.append('order_id', request_infos.order_id);
            await get_supplier_applicant_request_details(formData).then((response) => {
               //  console.log("get_supplier_applicant_request_details", request_infos, response.data);
                setinit_products_bysupplier(JSON.parse(response.data.products));
                setDetails(response.data);
                get_orders_products(JSON.parse(response.data.products), request_infos.request_code, response.data.order_number, response.data.order_state, response.data.service_accord, request_infos.order_id);
            }).catch((error) => {
                //console.log(error.response);
            });
            await check_weither_ispossible_to_proceed(formData).then((response) => {
               //  console.log("check_weither_ispossible_to_proceed : ", response.data);
                setRequest_validation_processes(response.data);
            }).catch((error) => {
               //  console.log(error.response);
            })
            await check_order_has_contract(formData)
                .then((response) => {
                   //  console.log("check_order_has_contract:", response.data);
                    setIs_off_cataloque(response.data.has_contract); // Assumes the backend returns { has_contract: true/false }
                })
                .catch((error) => {
                    console.error("Error in check_order_has_contract:", error.response || error);
                });
            await contract_check(request_infos.order_id, "all")
                .then((response) => {
                    if (response.data !== "") {
                        const rep = response.data;
                        // Build enriched object
                        const enrichedSubmission = {
                            id_submission: request_infos.order_id,
                            contract_type: Object.keys(rep)[0],
                            contract_subtypes: rep[Object.keys(rep)[0]],
                        };
                        setChosenSubmission(enrichedSubmission);
                       //  console.log("Enriched Submission:", enrichedSubmission);
                    }
                })
                .catch((error) => {
                    console.error("contract_check error:", error.response || error);
                });
        }
        load_data();
    }, []);

    function get_request_order_validation(validation_processes, order_id) {
        let order_validation_process = validation_processes.filter((proc) => proc.request_order_id == order_id);
        return order_validation_process;
    }

    function verify_request_order_validation(validation_processes, order_id) {
        let order_validation_process = validation_processes.filter((step) => step.request_order_id == order_id).sort((a, b) => (new Date(b.created_at) - new Date(a.created_at)));
        let able_to_proceed = true;
        let users_id = [];
        for (let step of order_validation_process) {
            if (!users_id.includes(step.user) && step.validated == 1) users_id.push(step.user);
            if (step.validated != 1 && !users_id.includes(step.user)) {
                able_to_proceed = false;
                users_id.push(step.user);
                break;
            }
        }
        //console.log("validation process : ", order_validation_process, users_id, able_to_proceed);
        return able_to_proceed;
    }

    async function reverify_request_order_validation(order_id) {
        const formData = new FormData();
        formData.append('request_code', request_infos.request_code);
        formData.append('order_id', order_id);
        let validation_processes = await check_weither_ispossible_to_proceed(formData).then((response) => {
           //  console.log("check_weither_ispossible_to_proceed : ", response.data);
            setRequest_validation_processes(response.data);
            return response.data;
        }).catch((error) => {
           //  console.log(error.response);
        });
        let order_validation_process = validation_processes.filter((step) => step.request_order_id == order_id).sort((a, b) => (new Date(b.created_at) - new Date(a.created_at)));
        let able_to_proceed = true;
        let users_id = [];
        for (let step of order_validation_process) {
            if (!users_id.includes(step.user) && step.validated == 1) users_id.push(step.user);
            if (step.validated != 1 && !users_id.includes(step.user)) {
                able_to_proceed = false;
                users_id.push(step.user);
                break;
            }
        }
        //console.log("validation process : ", order_validation_process, users_id, able_to_proceed);
        return able_to_proceed;
    }

    const handleNotifyRequester = (id_supplier, request_code, supplier_name) => {
       //  console.log(id_supplier, request_code, supplier_name, user);
        swal({
            title: "Etes-vous sûr ?",
            text: "!!!!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then(async (willDelete) => {
                if (willDelete) {
                    setwait_submitting(true);
                    let formData = new FormData();
                    formData.append('request_code', request_code);
                    formData.append('id_supplier', id_supplier);
                    formData.append('sender_name', supplier_name);
                    await notify_purchase_service_with_quote_upload(formData).then((response) => {
                       //  console.log("Notification sent successfully:", response.data);
                        swal("Le service d'achat a été notifié avec succès !", {
                            icon: "success",
                        });
                    }).catch((error) => {
                        console.error(error.response);
                        setwait_submitting(false);
                    });
                    setwait_submitting(false);
                }
            })
    }

    async function upload_quote(file, request_code, order_id) {
        setwait_submitting(true);
        let formData = new FormData();
        formData.append('request_code', request_code);
        formData.append('id_supplier', id_supplier);
        formData.append('quote_file', file);
        formData.append('order_id', order_id);

        await add_quote_to_orderRequest(formData).then((response) => {
            let tmp_details = { ...details };
            tmp_details.quote = response.data.quote_path;
            setDetails(tmp_details);
           //  console.log(response.data);
            setwait_submitting(false);
            swal("Le devis a été ajouté avec succès !", {
                icon: "success",
            });
        }).catch((error) => {
            console.error(error.response);
            setwait_submitting(false);
        });
        setwait_submitting(false);

    }

    async function download_quote(e, order_infos) {
        setwait_submitting(true);
        e.stopPropagation();
        let formData = new FormData();
        formData.append('request_code', order_infos.request_code);
        formData.append('order_id', order_infos.order_id);

        await download_orderRequest_quote(formData).then((response) => {
            const fileURL = window.URL.createObjectURL(new Blob([response.data]));
            const fileLink = document.createElement('a');
            fileLink.href = fileURL;

            let file_extension = 'pdf';
            const disposition = response.headers['content-disposition'];
            if (disposition && disposition.includes('filename')) {
                const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                const matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) {
                    file_extension = matches[1].replace(/['"]/g, '').split(".")[1];
                }
            }

            fileLink.setAttribute(
                'download',
                `${order_infos.request_code.replaceAll(" ", "_")}_${order_infos.order_id}_devis.${file_extension}`
            );
            document.body.appendChild(fileLink);
            fileLink.click();
        }).catch(err => {
            console.error("Error downloading quote", err);
        });
        setwait_submitting(false);
    }

    return (
        <Dialog disableEnforceFocus fullScreen open={request_infos.request_code ? true : false} onClose={() => setRequest_infos(null)} className="my_full_dialog contract_full_dialog">
            <AppBar className={classes.appBar}  >
                <Toolbar style={{ backgroundColor: '#343a40' }} >
                    <div className="contract_content_toolbar_main_container">
                        <div className="contract_content_toolbar_left">
                            <div className='page_title'>
                                <IconButton edge="start" color="inherit" onClick={() => setRequest_infos(null)} aria-label="close" >
                                    <CloseIcon className="my_icon" />
                                </IconButton>
                                <span> Details de demande : {request_infos.request_code} </span>
                            </div>
                        </div>
                        <div className='supplier_purchase_order_actions'>
                        {
                            details !== null && (details.order_state==null || details.order_state=='devis ajouté') && details.off_catalogue
                                ? <>
                                    <Tooltip title="Importer le devis" placement="bottom">
                                            <input
                                                accept='application/*'
                                                className={classes.input}
                                                id={'uploadQuote' + details.order_id}
                                                name={'uploadQuote' + details.order_id}
                                                type='file'
                                                onChange={(e) => upload_quote(e.target.files[0], details.request_code, details.order_id)}
                                            />
                                            <label htmlFor={'uploadQuote' + details.order_id} style={{ margin: '0' }}>
                                                <Fab variant="contained" color="warning" component="span" size="small" >
                                                    <CloudUploadIcon className="my_icon" />
                                                </Fab>
                                            </label>
                                    </Tooltip>                                    
                                </>
                                : <></>
                        }
                        {
                            details !== null &&  details.off_catalogue
                                ? <><Tooltip title="Télécharger le devis" placement="bottom">
                                        <span style={{ margin: '0 8px' }}>
                                            <Fab
                                                onClick={(e) => download_quote(e, details)}
                                                size="small"
                                                color="warning"
                                                className={details.quote !== null ? "round_button" : "round_button disabled_button"}
                                            >
                                                <DownloadIcon className="my_icon" />
                                            </Fab>
                                        </span>
                                    </Tooltip></>
                                :<></>
                        }
                        {
                            details !== null && (details.order_state==null || details.order_state=='devis ajouté') && details.off_catalogue
                                ? <>{details.quote && (<span>
                                        <Button className={!wait_submitting ? "submit_but valide_but" : "submit_but valide_but disabled_button"} endIcon={<NavigateNextIcon className="my_icon" />}
                                            onClick={() => handleNotifyRequester(id_supplier, details.request_code, user.fullName)}>
                                            Notifier le service d'achat
                                        </Button>
                                    </span>)}</>
                                :<></>
                        }
                        </div>
                    </div>
                </Toolbar>
            </AppBar>

            {
                details !== null && products_bysupplier !== null && init_products_bysupplier !== null
                    ? <div className="off_catalogue_requestDetails_container request_details_container">
                        <Request_detail
                            title="Détails"
                            details={details} />
                        <>
                            {
                                Object.keys(products_bysupplier).length !== 0
                                    ? <>
                                        {Object.keys(products_bysupplier).map((key, id) => (
                                            <Order_detail
                                                title={"Commande"}
                                                inner_state={inner_state}
                                                id_supplier={key.split("*")[0]}
                                                supplier={key.split("*")[1]}
                                                request_code={request_infos.request_code}
                                                request_order_validation={get_request_order_validation(request_validation_processes, products_bysupplier[key].order_id)}
                                                able_to_process_order={verify_request_order_validation(request_validation_processes, products_bysupplier[key].order_id)}
                                                reverify_request_order_validation={reverify_request_order_validation}
                                                details={products_bysupplier[key]} init_products_bysupplier={init_products_bysupplier}
                                                products_bysupplier={products_bysupplier} is_off_cataloque={is_off_cataloque} chosenSubmission={chosenSubmission} setChosenSubmission={setChosenSubmission}
                                                setProducts_bysupplier={setProducts_bysupplier} order_key={key} key={key} />
                                        ))
                                        }
                                    </>
                                    : <></>
                            }
                        </>
                        <div className="articles_container">
                            {
                                JSON.parse(details.products).articles ? JSON.parse(details.products).articles.map((article, id) => (
                                    <div className='articles_view_container' key={'articles' + id}>
                                        <div className="article_view_header_container">
                                            <span>Article n°{id + 1}</span>
                                        </div>
                                        <div>{article}</div>
                                    </div>
                                )) : <></>
                            }
                        </div>
                    </div>
                    : <Loading_animation_view />
            }
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={wait_submitting}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </Dialog>
    )
}

export default Request_details;
